import qs from "qs";
import request from "@/utils/requestSC";

// 保存授权信息
export async function getSaveRelationship(params = {}) {
  return request.post("rest/wx/saveRelationship", qs.stringify(params));
}
